module.exports = __webpack_public_path__ + "img/cross_ico_sure_4.070221c3.svg";